import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'reference-preview.broken-header': {
    id: 'reference-preview.broken-header',
    defaultMessage: 'Uh oh, we can’t embed this database',
    description:
      'The header text displayed in the database reference preview window when a broken database is selected.',
  },
  'reference-preview.broken-description': {
    id: 'reference-preview.broken-description',
    defaultMessage: 'This database may be broken. Try embedding a different database.',
    description:
      'The description text displayed in the database reference preview window when a broken database is selected.',
  },
  'reference-preview.placeholder': {
    id: 'reference-preview.placeholder',
    defaultMessage: 'Select a database, entry, or value to preview it here',
    description:
      'The text displayed in the database reference preview window when a database has not yet been selected.',
  },
  'reference-picker.header': {
    id: 'reference-picker.header',
    defaultMessage: 'Embed database',
    description: 'The header in the picker section of the database referencing wizard.',
  },
  'reference-picker.close': {
    id: 'reference-picker.close',
    defaultMessage: 'Close',
    description:
      'The aria label for the close button in the database referencing wizard.',
  },
  'reference-picker.optional': {
    id: 'reference-picker.optional',
    defaultMessage: '(optional)',
    description:
      'The text indicating an optional field in the database referencing wizard.',
  },
  'reference-picker.cancel': {
    id: 'reference-picker.cancel',
    defaultMessage: 'Cancel',
    description: 'The text for the cancel button in the database referencing wizard.',
  },
  'reference-picker.embed': {
    id: 'reference-picker.embed',
    defaultMessage: 'Embed',
    description: 'The text for the embed button in the database referencing wizard..',
  },
  'reference-database-picker.label': {
    id: 'reference-database-picker.label',
    defaultMessage: 'Database',
    description: 'The text heading a database picker in the database referencing wizard.',
  },
  'reference-database-picker.placeholder': {
    id: 'reference-database-picker.placeholder',
    defaultMessage: 'Search or paste link',
    description:
      'The text placeholder for a database picker in the database referencing wizard.',
  },
  'reference-entry-picker.label': {
    id: 'reference-entry-picker.label',
    defaultMessage: 'Entry',
    description: 'The text heading an entry picker in the database referencing wizard.',
  },
  'reference-value-picker.label': {
    id: 'reference-value-picker.label',
    defaultMessage: 'Value',
    description: 'The text heading a value picker in the database referencing wizard.',
  },
  'reference-entry-picker-option.add-icon-label': {
    id: 'reference-entry-picker-option.add-icon-label',
    defaultMessage: 'Create new entry',
    description:
      'The label for the add icon for a create option in the entry picker for the database referencing wizard.',
  },
  'reference-entry-picker-option.add-label': {
    id: 'reference-entry-picker-option.add-label',
    defaultMessage: 'Create new entry',
    description:
      'The label for the create new entry option in the entry picker for the database referencing wizard.',
  },
  'reference-entry-picker-option.unnamed-entry': {
    id: 'reference-entry-picker-option.unnamed-entry',
    defaultMessage: 'Unnamed entry',
    description: 'The text for an entry that has not been named.',
  },
  'reference-entry-picker.placeholder': {
    id: 'reference-entry-picker.placeholder',
    defaultMessage: 'Select or create an entry',
    description:
      'The text placeholder for an entry picker in the database referencing wizard.',
  },
  'reference-entry-picker.entry-optional-placeholder': {
    id: 'reference-entry-picker.entry-optional-placeholder',
    defaultMessage: 'Entry (optional)',
    description:
      'The text placeholder for an entry picker in the database referencing wizard.',
  },
  'reference-entry-picker.placeholder-no-creation': {
    id: 'reference-entry-picker.placeholder-no-creation',
    defaultMessage: 'Select an entry',
    description:
      'The text placeholder for an entry picker in the database referencing wizard when creation is not allowed (i.e. on a database where you only have view permissions).',
  },
  'reference-value-picker.placeholder': {
    id: 'reference-value-picker.placeholder',
    defaultMessage: 'Select a value by field',
    description:
      'The text placeholder for a value picker in the database referencing wizard.',
  },
  'reference-value-picker.value-optional-placeholder': {
    id: 'reference-value-picker.value-optional-placeholder',
    defaultMessage: 'Value (optional)',
    description:
      'The text placeholder for a value picker in the database referencing wizard.',
  },
  'reference-preview.entry-placeholder-header': {
    id: 'reference-preview.entry-placeholder-header',
    defaultMessage: 'Embed the entry to start editing',
    description:
      'The header text displayed in the database reference preview window when a create option entry is selected.',
  },
  'reference-preview.entry-placeholder-description': {
    id: 'reference-preview.entry-placeholder-description',
    defaultMessage: 'You can edit this entry and your changes will sync to the database.',
    description:
      'The description text displayed in the database reference preview window when a create option entry is selected.',
  },
  'reference-value-picker.no-options': {
    id: 'reference-value-picker.no-options',
    defaultMessage: 'No values to embed',
    description:
      'The message displayed when a value picker has no options in the database referencing wizard.',
  },
  'reference-entry-picker.no-options': {
    id: 'reference-entry-picker.no-options',
    defaultMessage: 'No entries to embed',
    description:
      'The message displayed when a entry picker has no options in the database referencing wizard.',
  },
  'reference-database-picker.menu-header': {
    id: 'reference-database-picker.menu-header',
    defaultMessage: 'RECENTLY VIEWED DATABASES',
    description:
      'The text heading the database picker menu in the database referencing wizard.',
  },
  'reference-database-picker.error-message': {
    id: 'reference-database-picker.error-message',
    defaultMessage: 'Select a valid database',
    description:
      'The error message displayed when there is a problem with the selected database',
  },
  'reference-database-picker.error-label': {
    id: 'reference-database-picker.error-label',
    defaultMessage: 'selection error',
    description:
      'The label for the error icon when there is a problem with the selected database',
  },
});
